/**
* Nom : trialDelete.js
* Description : Ce fichier contient la définition de la page trialDelete 
*               Cette page affiche un message de confirmation pour supprimer un essai
* Date de création : 27 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TrialDelete : affiche un message de confirmation pour supprimer un essai
*
* Type : page 
*
* Parametres : 
*  None
*/
function TrialDelete() {

    //Define useParam
    const { id } = useParams()


    // Define useState hooks
    const [oldTrial, setOldTrial] = useState(null)
    const [statusOldTrial, setStatusOldTrial] = useState(null)
    const [statusDeletedTrial, setStatusDeletedTrial] = useState(null)
    const [isDataLoading, setDataLoading] = useState(false)


    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();

    const navigate = useNavigate();


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData() {
        // Token
        const token = "Bearer " + authToken
        // Delete trial 
        const response = await fetch(path + "/api/bo-tral/" + id + "/", 
          {
            method: 'DELETE',
            credentials: 'include',
            mode: 'cors',
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token,
            }
          }
        );
        setStatusDeletedTrial(response["status"])
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        sendData()
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve trial details
        const resTrial = await fetch(path + "/api/bo-tral/" + id + "/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const data = await resTrial.json();
        setStatusOldTrial(resTrial["status"])
        setOldTrial(data)
        // Dataloading
        setDataLoading(false)
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(statusDeletedTrial === 204) {
            const treatment_path = '/trials/'
            navigate(treatment_path)
        } else {
            const treatment_path = '/trials/' + id + "/delete"
            navigate(treatment_path)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusDeletedTrial, navigate]);


    // Render component
    return (
        <div>
            <TabRD tabNumber={2}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        oldTrial ? (
                            <div>
                                {/*Lien de retour*/}
                                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                                    <div className='link-border'>
                                        <BackPage path={'/trials/' + id}>Retour au détail de l'essai</BackPage>
                                    </div>
                                </div>
                                <h1>Supprimer l'essai {oldTrial["name"]} ?</h1>
                                {(statusDeletedTrial !== null && statusDeletedTrial !== 204) ? (
                                    <div>
                                        <div className='flex-column form-center'>
                                            <div className='button button-text' onClick={handleSubmit}>Valider</div>
                                        </div>
                                        <p className='form-error'>L'essai ne peux pas être supprimé !</p>
                                    </div>
                                ) : (
                                    <div>
                                        <div className='flex-column form-center'>
                                            <div className='button button-text' onClick={handleSubmit}>Valider</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p>Essai non disponible {statusOldTrial} !</p>
                        )
                    )}
                </Container>
            </div>
        </div>
    );
}

export default TrialDelete;
